export enum UserTypeEnum {
  SUPER_ADMIN = 'AurricaAdmin',
  CARRIER_ADMIN = 'CarrierAdmin',
  CARRIER_MANAGER = 'CarrierManager',
  CARRIER_ITURAN = 'CarrierIturan',
  SHIPPER_ADMIN = 'ShipperAdmin',
}
